import { mapActions, mapState } from 'vuex'
import staticPathTitle ,{ staticPath } from '../../utils/baseUrl.js'
import store from "@/store/index.js";
export default {
    computed: {
        transcodeEventType() {
            return ({transcode, type=1}) => {
                let typeObj = {
                    1: 'click',
                    2: 'show'
                }
                return transcode == 1?  typeObj[type] : ''
            }
        }
    },
    methods: {
        ...mapActions('class',['videoTranscode']),
        transcode(id, parentId, type) {
            this.$confirm('确定将该视频进行转码？', '转码', {
                distinguishCancelAndClose: false,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: this.classNames + '_common_dialog',
                center: true
            })
            .then(async() => {
                await this.videoTranscode({ show_id:id, product_id: parentId })
                this[type]()
            })
            
        }
    }
}
export const authority = {
    data() {
        return {
            isAuthorityFlag: false,
            authorLoading: false
        }
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch('message/platform').then(res=> {
            if(res.platform.includes(staticPathTitle[staticPath].value)) {
                next((vm)=> {
                    vm.isAuthorityFlag = true
                })
            } else {
                next((vm)=> {
                    vm.isAuthorityFlag = false
                })
            }
        })
        // next((vm) => {
        //     vm.platformFun()
        //     return false
        // });
    },
    methods: {
        ...mapActions('message',['platform']),
        async platformFun() {
            try {
                let res = await this.platform()
                this.isAuthorityFlag = res.platform.includes(staticPathTitle[staticPath].value)
                this.$nextTick(() => {
                    this.authorLoading = true
                })
            } catch (error) {
                this.authorLoading = true
                this.isAuthorityFlag = false
            }
        }
    }
}

// 异步导出相关 
// p.s: 以后尽量用这个，别再单写了 -_-
export const exportAboutMixin = {
    methods: {
        ...mapActions('export', ['createExportAPI']),
        // 异步导出
        exportExcel(type, searchObj={}){
            // type 1用户订单 2退款订单 3申诉订单 4发货订单 5线索订单 6课程销量 9订单明细 10收益明细
            // searchObj 筛选参数
            this.$confirm('5分钟内仅可导出一次,导出后可在导出记录中查看导出进度,导出成功的数据请在24小时内下载', '导出提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '导出',
                cancelButtonText: '取消'
            })
            .then(async() => {
                await this.createExportAPI({
                    type: type,
                    search_params: {
                        ...searchObj,
                        excel: 1
                    }
                })
                this.$router.push({
                    path: this.staticPath + "exportHistory"
                })
            })
        }
    }
}

// 面包屑相关 
export const breadcrumbsMixin = {
    computed:{
        ...mapState(['breadCrumbList'])
    },
    methods: {
        // 解决三级面包屑不显示的问题
        mixin_handleBreadCrumb(path, name, id, index = 2) {
            let breadCrumbList = this.breadCrumbList
            breadCrumbList[index] = {
                title: name,
                path: id ? path + '/' + id : path
            }
            localStorage.setItem('breadCrumbList', JSON.stringify(breadCrumbList))
            this.$router.push({
                path: id ? path + '/' + id : path,
            })
            breadCrumbList[index] = {
                title: name,
                path: this.$route.fullPath
            }
        },
    }
}


